export default "__VITE_ASSET__rjml0Y2a__"